export const educationFormNames = {
  FfileGroup: 'fileGroup',
  Feducation: 'education',
};

export const getGroupNameInEducationObj = (groupId) => `${educationFormNames.Feducation}[${groupId}]`;
